export type DeliveryOption = "email" | "sms" | "both";

export interface ChannelAvailability {
	email: boolean;
	sms: boolean;
	both: boolean;
	// True when the patient can receive nothing at all — the dialog's blocked state.
	none: boolean;
}

// The twin of notification's own skip conditions (CommunicationController.php:461 and :483),
// which read the same `users` row this patient came from.
export const getChannelAvailability = (
	patient?: { email?: string | null; phone?: string | null } | null,
): ChannelAvailability => {
	// Never `patient_info.additional_emails`: no notification path reads that field, so counting
	// it as an email would promise a send the server would skip — the bug this module fixes.
	const email = String(patient?.email ?? "").trim() !== "";
	const sms = String(patient?.phone ?? "").trim() !== "";

	return { email, sms, both: email && sms, none: !email && !sms };
};

export const isDeliveryOptionAvailable = (
	option: DeliveryOption,
	availability: ChannelAvailability,
): boolean => availability[option];

// Email first: it is the current default and the cheaper channel.
export const firstAvailableOption = (
	availability: ChannelAvailability,
): DeliveryOption | null => {
	if (availability.email) return "email";
	if (availability.sms) return "sms";
	return null;
};
